// Constants shared between `location-map.tsx` (client-only, imports leaflet
// which touches `window` at module load) and `locations-client.tsx` (a client
// component that still gets prerendered on the server). Keeping these in a
// leaflet-free module lets `locations-client.tsx` import them statically
// without dragging leaflet into the prerender pass.

// Expand cluster pins into individual pins at this zoom. 9.0 puts the
// outermost members of a CLUSTER_RADIUS (~25km) group ~120px apart at
// pin size ~36px, which is when they cleanly stop overlapping. Stays in
// sync with the `isZoomedIn` / "back to country" thresholds in
// `locations-client.tsx`.
export const CLUSTER_ZOOM_THRESHOLD = 9.0
